import { Input } from "./ui";
import { useState } from "react";

// Helper function to format numbers without unnecessary trailing zeros
const formatNumber = (num) => {
    if (num === undefined || num === null || isNaN(num)) {
        return 0;
    }
    return Number(Number(num).toFixed(1));
};

const WindowEdit = (props) => {

    const windowDimensions = props.floorplanner.getWindowDimensions();
    const [windowWidth, setWidth] = useState(windowDimensions?.w || 100);
    const [windowHeight, setHeight] = useState(windowDimensions?.h || 100);

    const handleWidthChange = (newWidth)=>{
        const width = parseFloat(newWidth) || 0;
        setWidth(width);
        props.floorplanner.setWindowDimensions(width, windowHeight);
    }

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            width: "180px",
            padding: "10px",
            gap: "5px",
        }}>
            <label style={{ fontSize: "12px", alignSelf: "flex-start", marginBottom: "-2px" }}>
                Window width (cm)
            </label>
            <Input type="number"
                step={0.1}
                value={formatNumber(windowWidth)} 
                onChange={(evt)=>{handleWidthChange(evt.target.value)}}/>
        </div>
    )
}

export default WindowEdit;